/**
 * Vehicle images js
 *
 * @class VehicleImages
 */
class VehicleImages {

  constructor(){
    this.vehicleImageContainer = document.querySelector('.autokuva360');
    this.iframeControllers = this.vehicleImageContainer?.querySelectorAll('.carousel-360-thumb');
    this.imageControllers = this.vehicleImageContainer?.querySelectorAll('.carousel-360-thumb-car');
    this.mouseGuardian = this.vehicleImageContainer?.querySelector('.autokuva360__mouse-guardian');
    this.imageContainer = this.vehicleImageContainer?.querySelector('.image-carousel');
  }

  /**
   * Init vehicle image thumbnail clicks
   *
   * @memberof VehicleImages
   */
  initImages() {
    this.imageControllers?.forEach(imageController => {
      imageController.addEventListener('click', e => {
        const imageElement = imageController.querySelector('img')?.cloneNode(false);
        this.imageContainer.innerHTML = '';
        this.imageContainer.appendChild(imageElement);
      });
    });
  }

  /**
   * Init vehicle 360 iframe clicks
   *
   * @return {boolean} false if required elements are not present
   * @memberof VehicleImages
   */
  init360() {
    this.mouseGuardian?.addEventListener('click', e => {
      this.mouseGuardian.remove();
    });

    const iframeTemplateElement = this.vehicleImageContainer?.querySelector('iframe');

    if(!iframeTemplateElement) return false;

    this.iframeControllers.forEach(controller => {
      controller.addEventListener('click', e => {
        const source = controller.dataset.iframeSource;
        const iframeElement = iframeTemplateElement?.cloneNode(false);
        iframeElement.setAttribute('src', source);
        this.imageContainer.innerHTML = '';
        this.imageContainer.appendChild(iframeElement);
      });
    });
  }

  /**
   * Add active class to the scroller item that has been clicked
   *
   * @memberof VehicleImages
   */
  initScrollerState() {
    const scrollers = [...this.iframeControllers, ...this.imageControllers];

    scrollers.forEach(scroller => {
      scroller.addEventListener('click', e => {
        scrollers.forEach(s => s.classList.remove('active'));
        scroller.classList.add('active');
      });
    });
  }



  init() {
    if (this.vehicleImageContainer) {
      this.initImages();
      this.init360();
      this.initScrollerState();
    }
  }

}

export default new VehicleImages();
